module.exports = __webpack_public_path__ + "img/report-mangment-img.075a41cc.png";